/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Signup_EyebrowInputs */

const en_auth_signup_eyebrow = /** @type {(inputs: Auth_Signup_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create an account`)
};

const pl_auth_signup_eyebrow = /** @type {(inputs: Auth_Signup_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utwórz konto`)
};

/**
* | output |
* | --- |
* | "Create an account" |
*
* @param {Auth_Signup_EyebrowInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const auth_signup_eyebrow = /** @type {((inputs?: Auth_Signup_EyebrowInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Signup_EyebrowInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_auth_signup_eyebrow(inputs)
	return en_auth_signup_eyebrow(inputs)
});